import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MAIN = [
  { path: '/home',    icon: 'fa-house',          label: 'Home' },
  { path: '/chat',    icon: 'fa-comment-dots',   label: 'VIVI Coach' },
  { path: '/learn',   icon: 'fa-book-open',      label: 'Learn' },
  { path: '/consult', icon: 'fa-calendar-check', label: 'Consult' },
  { external: 'https://www.intiviv.com', icon: 'fa-bag-shopping', label: 'Store' },
];

const EXPLORE = [
  { path: '/ritual',       icon: 'fa-spa',             label: 'The Ritual' },
  { path: '/assessments',  icon: 'fa-clipboard-check', label: 'Assessments' },
  { path: '/journeys',     icon: 'fa-route',           label: 'Journeys' },
  { path: '/couple',       icon: 'fa-heart',           label: 'Couple Space' },
  { path: '/exercises',    icon: 'fa-hand-holding-heart', label: 'Couple Exercises' },
  { path: '/affirmations', icon: 'fa-sun',             label: 'Affirmations' },
];

export default function SideNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();

  const renderItem = (t) => {
    const isActive = t.path && pathname.startsWith(t.path);
    const onTap = () => {
      if (t.external) window.open(t.external, '_blank', 'noopener,noreferrer');
      else navigate(t.path);
    };
    return (
      <button
        key={t.label}
        className={`side-nav-item${isActive ? ' active' : ''}`}
        onClick={onTap}
        data-testid={`sidenav-${t.label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <i className={`fa-solid ${t.icon}`} />
        <span>{t.label}</span>
      </button>
    );
  };

  const initials = (user?.name || 'U').split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();

  return (
    <aside className="side-nav" data-testid="side-nav">
      <div className="side-nav-silk" aria-hidden="true" style={{ backgroundImage: "url('/assets/luxe-gold-silk-v2.png')" }} />
      <div className="side-nav-logo" onClick={() => navigate('/home')} role="button">
        <img src="/intiviv-logo.png?v=4" alt="INTIVIV" />
      </div>

      <div className="side-nav-section">{MAIN.map(renderItem)}</div>

      <div className="side-nav-divider"><span>Explore</span></div>
      <div className="side-nav-section">{EXPLORE.map(renderItem)}</div>

      {user?.role === 'admin' && (
        <>
          <div className="side-nav-divider"><span>Manage</span></div>
          <div className="side-nav-section">
            {renderItem({ path: '/admin', icon: 'fa-gauge-high', label: 'Admin' })}
          </div>
        </>
      )}

      <div className="side-nav-footer">
        <button
          className={`side-nav-user${pathname.startsWith('/you') ? ' active' : ''}`}
          onClick={() => navigate('/you')}
          data-testid="sidenav-profile"
        >
          <div className="side-nav-avatar">{initials}</div>
          <div className="side-nav-user-meta">
            <div className="side-nav-user-name">{user?.name || 'You'}</div>
            <div className="side-nav-user-sub">My Profile</div>
          </div>
        </button>
      </div>
    </aside>
  );
}
